import React, { useState, useEffect } from 'react';
import { auth } from '../firebase';

export const DebugOverlay: React.FC = () => {
  const [errors, setErrors] = useState<any[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const originalError = console.error;
    console.error = (...args: any[]) => {
      if (args[0] && typeof args[0] === 'string' && args[0].includes('Firestore Error:')) {
        try {
          const errorData = JSON.parse(args[0].replace('Firestore Error: ', ''));
          setErrors(prev => [errorData, ...prev].slice(0, 5));
          setIsVisible(true);
        } catch (e) {
          // Fallback if parsing fails
          setErrors(prev => [{ error: String(args[0]) }, ...prev].slice(0, 5));
          setIsVisible(true);
        }
      }
      originalError.apply(console, args);
    };

    return () => {
      console.error = originalError;
    };
  }, []);

  if (!isVisible || errors.length === 0) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[9999] max-w-sm w-full bg-red-50 border-2 border-red-200 rounded-xl shadow-2xl p-4 font-sans overflow-hidden">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-red-800 font-bold flex items-center gap-2">
          <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
          System Error Log
        </h3>
        <button 
          onClick={() => setIsVisible(false)}
          className="text-red-400 hover:text-red-600 p-1"
        >
          ✕
        </button>
      </div>
      <div className="space-y-3 max-h-64 overflow-y-auto pr-2">
        {errors.map((err, i) => (
          <div key={i} className="text-xs bg-white p-3 rounded-lg border border-red-100 shadow-sm">
            <div className="font-bold text-red-700 mb-1 uppercase tracking-wider">
              {err.operationType || 'Error'} @ {err.path || 'Unknown Path'}
            </div>
            <div className="text-gray-600 break-words mb-2">
              {err.error}
            </div>
            <div className="bg-gray-50 p-2 rounded border border-gray-100 font-mono text-[10px]">
              User: {err.authInfo?.email || 'Not Logged In'}<br/>
              UID: {err.authInfo?.userId || 'N/A'}
            </div>
          </div>
        ))}
      </div>
      <button 
        onClick={() => setErrors([])}
        className="mt-3 w-full py-1.5 text-[10px] font-bold uppercase tracking-widest text-red-500 hover:bg-red-100 rounded transition-colors"
      >
        Clear Log
      </button>
    </div>
  );
};
